require('./markerCluster.js')

export default
{
    props:
    {
        content: { type: Object, default: null }
    },

    data()
    {
        return {
            activeIndex: 0,
            mouse: {
                x: 0,
                y: 0,
                smooth: {
                    x: 0,
                    y: 0
                }
            },
        }
    },

    created()
    {
        this._center = {
            lat: 48.8534100,
            lng: 2.3488000
        }

        this._zoom = 6

        this.eventHub.$on('window:tick', this.onTick)
    },


    mounted()
    {
        this.$modalsProject = this.$el.querySelectorAll('.js-modal-project')
        this.$modalsConference = this.$el.querySelectorAll('.js-modal-conference')

        this.initMap()

        this.showMarkers(0)

        this.$nextTick(() =>
        {
            if(this.getURLParameter('project'))
            {
                for(let i = 0; i < this.content.projects.length; i++)
                {
                    if(this.content.projects[i].post_name === this.getURLParameter('project'))
                    {
                        const bounds = new google.maps.LatLngBounds()

                        bounds.extend(this._markers[i].getPosition())

                        this._infoWindow[i].open(this._map, this._markers[i])

                        this._map.fitBounds(bounds)

                        this._map.setZoom(this._map.getZoom() + 4)
                    }
                }
            }
            else if(this.getURLParameter('conference'))
            {
                this.onBtnClick(1)

                for(let i = 0; i < this.content.conferences.length; i++)
                {
                    if(this.content.conferences[i].post_name === this.getURLParameter('conference'))
                    {
                        const bounds = new google.maps.LatLngBounds()

                        bounds.extend(this._markers[i].getPosition())

                        this._infoWindow[i].open(this._map, this._markers[i])

                        this._map.fitBounds(bounds)

                        this._map.setZoom(this._map.getZoom() + 4)
                    }
                }
            }
        })

        this.$emit('page:ready')
    },

    destroyed()
    {
        this.eventHub.$off('window:tick', this.onTick)
    },

    methods:
    {
        onBtnClick(index)
        {
            this.activeIndex = index

            this.hideMarkers()
            this.showMarkers(this.activeIndex)

            this._map.setZoom(this._zoom)
            // this._map.panTo(this._center)
        },

        initMap()
        {
            this._map = new google.maps.Map(this.$el.querySelector('.js-map'), {
                center: this._center,
                disableDefaultUI: true,
                zoom: this._zoom,
                minZoom: 4,
                styles: require('./map.json')
            })


            google.maps.event.addListenerOnce(this._map, 'bounds_changed', (event) =>
            {
                if (this._map.getZoom() > 15)
                {
                    this._map.setZoom(15)
                }
            })
        },

        addMarkers(content, index)
        {
            this._markers = []

            this._infoWindow = []

            for(let i = 0; i < content.length; i++)
            {
                const marker = new google.maps.Marker({
                    position:
                    {
                        lat: +content[i].localisation.lat,
                        lng: +content[i].localisation.lng
                    },
                    icon:
                    {
                        url: this.$root.globalContent.settings.marker.url,
                        scaledSize: new google.maps.Size(15, 15)
                    },
                    map: this._map
                })

                this._markers.push(marker)

                const div = index === 0 ? this.$modalsProject[i] : this.$modalsConference[i]

                const infowindow = new google.maps.InfoWindow({
                    content: div
                })

                this._infoWindow.push(infowindow)

                marker.addListener('click', () =>
                {
                    for(let i = 0; i < this._infoWindow.length; i++)
                    {
                        this._infoWindow[i].close()
                    }

                    this._map.panTo(marker.position)
                    infowindow.open(this._map, marker)
                })

            }

            const markerCluster = new MarkerClusterer(this._map, this._markers, {
                imagePath: '/static/icons/marker'
            }, this.$root.color[0])


            return markerCluster
        },

        showMarkers(index)
        {
            if(index === 0)
            {
                this._markersGroup = this.addMarkers(this.content.projects, 0)
            }
            else
            {
                this._markersGroup = this.addMarkers(this.content.conferences, 1)
                this.eventHub.$emit('set:magmaContent', this.content.conferences)
            }
        },

        hideMarkers()
        {
            this._markersGroup.clearMarkers()
        },

        onMouseMove(event)
        {
            // give a ratio between -1 & 1
            this.mouse.x = ((event.pageX / this.$root.window.width) - 0.5) * 2
            this.mouse.y = ((event.pageY / this.$root.window.height) - 0.5) * 2
        },

        onTick()
        {
            this.mouse.smooth.x += (this.mouse.x - this.mouse.smooth.x) * 0.1
            this.mouse.smooth.y += (this.mouse.y - this.mouse.smooth.y) * 0.1
        },

        getURLParameter(name)
        {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-page-map/script.js